/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectInformationResourceQuoteLinesInner
 */
export interface ProjectInformationResourceQuoteLinesInner {
    /**
     * 
     * @type {string}
     * @memberof ProjectInformationResourceQuoteLinesInner
     */
    description: string;
    /**
     * 
     * @type {number}
     * @memberof ProjectInformationResourceQuoteLinesInner
     */
    quantity: number;
    /**
     * 
     * @type {number}
     * @memberof ProjectInformationResourceQuoteLinesInner
     */
    unitPriceExcludingTaxes: number;
    /**
     * 
     * @type {number}
     * @memberof ProjectInformationResourceQuoteLinesInner
     */
    totalExcludingTaxes: number;
}

/**
 * Check if a given object implements the ProjectInformationResourceQuoteLinesInner interface.
 */
export function instanceOfProjectInformationResourceQuoteLinesInner(value: object): value is ProjectInformationResourceQuoteLinesInner {
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    if (!('unitPriceExcludingTaxes' in value) || value['unitPriceExcludingTaxes'] === undefined) return false;
    if (!('totalExcludingTaxes' in value) || value['totalExcludingTaxes'] === undefined) return false;
    return true;
}

export function ProjectInformationResourceQuoteLinesInnerFromJSON(json: any): ProjectInformationResourceQuoteLinesInner {
    return ProjectInformationResourceQuoteLinesInnerFromJSONTyped(json, false);
}

export function ProjectInformationResourceQuoteLinesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectInformationResourceQuoteLinesInner {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'],
        'quantity': json['quantity'],
        'unitPriceExcludingTaxes': json['unitPriceExcludingTaxes'],
        'totalExcludingTaxes': json['totalExcludingTaxes'],
    };
}

export function ProjectInformationResourceQuoteLinesInnerToJSON(value?: ProjectInformationResourceQuoteLinesInner | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'description': value['description'],
        'quantity': value['quantity'],
        'unitPriceExcludingTaxes': value['unitPriceExcludingTaxes'],
        'totalExcludingTaxes': value['totalExcludingTaxes'],
    };
}

